import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@web/components/ui/card';

import { ReplySuggestions } from './reply-suggestions';
import { forwardRef } from 'react';

export const SuggestionsBubble = forwardRef<
  HTMLDivElement,
  {
    suggestions: { uuid: string; content: string }[];
    onSelectReply?: (message: { uuid: string; content: string }) => void;
  }
>(({ suggestions, onSelectReply }, ref) => {
  return (
    <Card ref={ref} className="max-w-[75%] self-end rounded-xl p-3 shadow-sm border border-blue-100 bg-blue-50">
      <CardHeader className="p-0 pb-2">
        <CardTitle className="text-blue-600 text-xs font-medium">
          {suggestions.length} suggested {suggestions.length === 1 ? 'reply' : 'replies'}
        </CardTitle>
      </CardHeader>

      <CardContent className="p-0">
        <ReplySuggestions
          suggestions={suggestions}
          onSelectReply={onSelectReply}
        />
      </CardContent>
    </Card>
  );
});

SuggestionsBubble.displayName = 'SuggestionsBubble';
